import get from 'lodash.get';
import envList from '../constants/envList';
import ProductType from '../constants/ProductType';
import ProductService from './ProductService';

class StandardService {
  static getProducts(env, preselect, source, isolationValue) {
    let products;
    switch (env) {
      case envList.CA.path: {
        const suspentes = ProductService.getSuspentesOptions(source);
        const suspentesStandardPrice = (suspentes[9] && suspentes[9].value.price) || 0;

        const productOptions = ProductService.getAllOptions(source);
        const membrane = ProductService.getMembraneOptions(source);

        const adhesifs = ProductService.getAdhesifOptions(source);
        const adhesifStandardPrice = adhesifs[3].value.price;
        const solidoubleStandardPrice = adhesifs[2].value.price;

        const mastics = ProductService.getMasticOptions(source);
        const masticStandardPrice = mastics[0].value.price;

        const entreChevronsItemId = get(
          preselect.find(
            i => (i.solution_id === 1 && i.entreousouschevron === 1)
          ),
          'product_id',
          null
        );

        const sousChevronItemId = get(
          preselect.find(
            i => (i.solution_id === 1 && i.entreousouschevron === 2)
          ),
          'product_id',
          null
        );

        const adhesifItemId = get(
          preselect.find(
            i => (i.solution_id === 1 && i.type_id === 5)
            && adhesifs.find(
              adhesif => adhesif.key === i.product_id
            )
          ),
          'product_id',
          null
        );

        const membraneItem = membrane.find(({ key }) => key === 93).value;
        const suspentesItem = (suspentes[9] && suspentes[9].value) || 0;
        const entreChevronsItem = get(
          productOptions.find(
            productOption => productOption.key === entreChevronsItemId
          ),
          'value',
          null
        );

        const sousChevronsItem = get(
          productOptions.find(
            productOption => productOption.key === sousChevronItemId
          ),
          'value',
          null
        );

        membraneItem.membraneRouleaux = Math.ceil((isolationValue * 1.3) / 75);

        const selectedAdhesif = get(
          adhesifs.find(
            adhesif => adhesif.key === adhesifItemId
          ),
          'value',
          {
            m2perpiece: 1.6,
            pieceperpackage: 40,
            price: 26.13,
          }
        );

        products = {
          adhesifs,
          adhesifStandardPrice,
          entreChevronsItem,
          entreChevronsItemId,
          mastics,
          masticStandardPrice,
          membrane,
          membraneItem,
          productOptions,
          selectedAdhesif,
          solidoubleStandardPrice,
          sousChevronItemId,
          sousChevronsItem,
          suspentes,
          suspentesItem,
          suspentesStandardPrice,
        };
        break;
      }
      case envList.IME.path: {
        const insulators = ProductService.getInsulatorOptions(source);
        const supports = ProductService.getSupportOptions(source);
        const adhesifsIME = ProductService.getAdhesifOptions(source);

        const selectedInsulator = get(insulators.find(
          insulator => (insulator.value.workstype.includes('1')
            && preselect.find(
              pre => pre.product_id === insulator.key
              && pre.solution_id === 4
            ))
        ), 'value', null);

        const selectedSupport = get(supports.find(
          support => (support.value.workstype.includes('1')
            && preselect.find(
              pre => pre.product_id === support.key
              && pre.solution_id === 4
            ))
        ), 'value', null);

        const selectedAdhesif = get(adhesifsIME.find(
          adhesif => adhesif.value.workstype.includes('1')
            && preselect.find(
              pre => pre.product_id === adhesif.key
              && pre.solution_id === 4
            )

        ), 'value', null);

        products = {
          insulators,
          supports,
          selectedInsulator,
          selectedSupport,
          adhesifsIME,
          selectedAdhesif,
        };
        break;
      }
      case envList.CP.path: {
        const insulators = ProductService.getInsulatorOptions(source);
        const adhesives = ProductService.getAdhesifOptions(source);
        const membranes = ProductService.getMembraneOptions(source);
        const mastics = ProductService.getMasticOptions(source);

        const selectedInsulator = get(
          insulators.find(
            insulator => (
              insulator.value.workstype.includes('1')
              && preselect.find(
                pre => pre.product_id === insulator.key && pre.solution_id === 7
              )
            )
          ),
          'value',
          null,
        );

        const selectedMembrane = get(
          membranes.find(
            membrane => (
              membrane.value.workstype.includes('1')
              && preselect.find(
                pre => pre.product_id === membrane.key && pre.solution_id === 7
              )
            )
          ),
          'value',
          null,
        );

        const selectedAdhesive = get(
          adhesives.find(
            adhesive => (
              adhesive.value.workstype.includes('1')
              && preselect.find(
                pre => pre.product_id === adhesive.key && pre.solution_id === 7
              )
            )
          ),
          'value',
          null,
        );

        const selectedMastic = get(
          mastics.find(
            mastic => (
              mastic.value.workstype.includes('1')
              && preselect.find(
                pre => pre.product_id === mastic.key && pre.solution_id === 7
              )
            )
          ),
          'value',
          null,
        );

        products = {
          insulators,
          adhesives,
          membranes,
          selectedInsulator,
          selectedMembrane,
          selectedAdhesive,
          selectedMastic,
        };

        break;
      }
      default: products = {};
    }

    return products;
  }

  static calculateCost(products, isolationValue, env = envList.CA.path) {
    const costs = {};

    products.forEach((product) => {
      const { productData: data } = product;
      switch (product.type) {
        case ProductType.INSULATOR: {
          let nbRoll = 0;

          const usedInsulator = Math.ceil(
            isolationValue * (
              (data && data.m2perpiece) || 0
            )
          );
          if (data && data.m2perpackage) {
            nbRoll = Math
              .ceil(
                (usedInsulator / (data && data.m2perpackage)) || 0
              );
          }

          const insulatorCost = (usedInsulator * (data && data.price)) || 0;

          costs.insulator = {
            nbRoll,
            usedInsulator,
            insulatorCost,
          };
          break;
        }
        case ProductType.SUPPORT:
          switch (env) {
            case envList.CA.path:
              let nbBox = 0;

              if (data && data.pieceperpackage && data.m2perpiece) {
                nbBox = Math.ceil(
                  (isolationValue / data.m2perpiece) / data.pieceperpackage
                );
              }
              const usedSupport = Math.ceil(nbBox * ((data && data.pieceperpackage) || 0));
              const supportCost = nbBox * (data && data.price) || 0;

              costs.support = {
                nbBox,
                usedSupport,
                supportCost,
              };
              break;
            case envList.IME.path:
              let nbBoxIme = 0;
              let usedSupportIME = 0;
              let supportCostIME = 0;

              if (data && data.m2perpiece) {
                nbBoxIme = Math.ceil(
                  (isolationValue / data.m2perpiece) / data.pieceperpackage
                );
              }
              usedSupportIME = Math.ceil(
                nbBoxIme * ((data && data.pieceperpackage) || 0)
              );
              supportCostIME = nbBoxIme * (data && data.price) || 0;

              costs.support = {
                nbBox: nbBoxIme,
                usedSupport: usedSupportIME,
                supportCost: supportCostIME,
              };
              break;
            default:
              break;
          }

          break;
        case ProductType.BETWEEN_CHEVRON:
          const selectedItem = data || { isolated_coeff: 0, price: 0 };
          const surface = isolationValue * Number(selectedItem.isolated_coeff);
          const nbRouleau = Math.ceil(surface / selectedItem.value_unit);

          const tarifPerSurface = selectedItem.price * surface;

          costs.betweenChevron = {
            surface,
            nbRouleau,
            tarifPerSurface,
          };
          break;
        case ProductType.UNDER_CHEVRON:
          const selectedItemUnder = data || { isolated_coeff: 0, price: 0 };
          const surfaceSousChevrons = isolationValue * Number(selectedItemUnder.isolated_coeff);
          const nbreRouleau = Math.ceil(surfaceSousChevrons / selectedItemUnder.m2perpackage);

          const tarifOnSurface = selectedItemUnder.price * surfaceSousChevrons;

          costs.underChevron = {
            surfaceSousChevrons,
            nbreRouleau,
            tarifOnSurface,
          };
          break;
        case ProductType.MEMBRANE:
          switch (env) {
            case envList.CA.path:
              let pareVapeur = '';
              if (data.id === 92) {
                pareVapeur = 'https://www.knaufinsulation.fr/produits/frein-vapeur-rt-max-2';
              } else if (data.id === 93) {
                pareVapeur = 'https://www.knaufinsulation.fr/produits/pare-vapeur-rt-max-18';
              } else if (data.id === 94) {
                pareVapeur = 'https://www.knaufinsulation.fr/produits/pare-vapeur-rt-max-90';
              }

              const membranePareVapeurRtmax = isolationValue * Number(data.m2perpiece);

              const tarifMembrane = isolationValue * Number(data.m2perpiece)
                * (data && data.price) || 0;

              costs.membrane = {
                membranePareVapeurRtmax,
                tarifMembrane,
                pareVapeur,
              };
              break;
            case envList.IME.path:
              let nbBox = 0;
              let usedMembrane = 0;
              let membraneCost = 0;

              if (data && data.m2perpiece && data.pieceperpackage) {
                nbBox = Math.ceil(
                  (isolationValue / data.m2perpiece) / data.pieceperpackage
                );
              }

              usedMembrane = Math.ceil(isolationValue * ((data && data.m2perpiece) || 0));
              membraneCost = nbBox * (data && data.price) || 0;

              costs.membrane = {
                membranebox: nbBox,
                usedMembrane,
                membraneCost,
              };
              break;
            case envList.CP.path:
              const used = isolationValue * (data && data.m2perpiece) || 0;
              const nbRoll = Math.ceil(used / (data && data.pieceperpackage) || 0);
              const cost = /* (data && data.pieceperpackage) * */ nbRoll * (data && data.price) || 0;

              costs.membrane = {
                usedMem: used,
                nbRollMem: nbRoll,
                costMem: cost,
              };
              break;
            default:
              costs.membrane = {
                used: 0,
                nbRoll: 0,
                cost: 0,
              };
              break;
          }

          break;
        case ProductType.ADHESIVE: {
          let nbBox = 0;
          let usedAdhesif = 0;
          let adhesifCost = 0;

          usedAdhesif = Math.ceil(isolationValue * ((data && data.m2perpiece) || 0));

          if (
            data && data.pieceperpackage
          ) {
            nbBox = Math.ceil(
              usedAdhesif / data.pieceperpackage
            );
          }

          adhesifCost = nbBox * (data && data.price) || 0;

          costs.adhesive = {
            adhesifBox: nbBox,
            usedAdhesif,
            adhesifCost,
          };
          break;
        }
        case ProductType.SOLIDOUBLE:
          const tarifSolidouble = data.quantity * data.price;
          costs.solidouble = {
            tarifSolidouble,
          };
          break;
        case ProductType.MASTIC:
          switch (env) {
            case envList.CA.path:
              const tarifMasticRt = data.quantity * data.price;
              costs.mastic = {
                tarifMasticRt,
              };
              break;
            default:
              let nbBox = 0;
              let usedMastic = 0;
              let masticCost = 0;

              if (data) {
                usedMastic = Math.ceil(isolationValue * data.m2perpiece);
                nbBox = Math.ceil(
                  usedMastic / data.pieceperpackage
                );
                masticCost = nbBox * data.price;
              }

              costs.mastic = {
                masticBox: nbBox,
                usedMastic,
                masticCost,
              };
              break;
          }
          break;
        case ProductType.SHROUD:
          if (data) {
            const qteUsed = Math.ceil(isolationValue * 2.5);
            const nbBox = Math.ceil(qteUsed / 50);
            const tarifDeSurface = nbBox * data.price;
            costs.shroud = {
              tarifDeSurface,
              nbBox,
              qteUsed,
            };
          } else {
            costs.shroud = {
              tarifDeSurface: 0,
              nbBox: 0,
              qteUsed: 0,
            };
          }
          break;
        case ProductType.PASTILLE: {
          let nbBoxP = 0;
          if (data && data.m2perpiece && data.pieceperpackage) {
            nbBoxP = Math.ceil(
              (isolationValue / data.m2perpiece) / data.pieceperpackage
            );
          }
          const usedPastille = Math.ceil(isolationValue * ((data && data.m2perpiece) || 0));
          const pastilleCost = nbBoxP * (data && data.price) || 0;

          costs.pastille = {
            pastilleBox: nbBoxP,
            usedPastille,
            pastilleCost,
          };
        }
          break;
        case ProductType.INSULATOR_BLOWN: {
          const usedIns = (data && data.thick_before_crush) || 0;
          let nbRollIns = 0;
          if (data && data.covering_power_kg_m2) {
            nbRollIns = isolationValue * data.covering_power_kg_m2;
          }

          const costIns = (data && data.price) * nbRollIns;

          costs.insulatorBlown = {
            costInsBlown: costIns,
            usedInsBlown: usedIns,
            nbRollInsBlown: nbRollIns,
          };
          break;
        }
        case ProductType.INSULATOR_BETWEEN: {
          const usedInsBet = isolationValue * 1.05;

          let nbRollInsBet = 0;
          let costInsBet = 0;
          if (data && data.m2perpackage) {
            nbRollInsBet = Math.ceil(usedInsBet / data.m2perpackage);
            costInsBet = (data && data.price)
              * (nbRollInsBet * (data && data.m2perpackage));
          }

          costs.insulatorBetween = {
            usedInsBet,
            nbRollInsBet,
            costInsBet,
          };
          break;
        }
        case ProductType.INSULATOR_SECOND: {
          if (data) {
            const usedSec = isolationValue * 1.05;
            let nbRollSec = 0;
            let costSec = 0;
            if (data && data.m2perpackage) {
              nbRollSec = Math.ceil(usedSec / data.m2perpackage);
              costSec = (data && data.price)
                * (nbRollSec * (data && data.m2perpackage));
            }


            costs.insulatorSecond = {
              costSec,
              usedSec,
              nbRollSec,
            };
          } else {
            costs.insulatorSecond = {
              costSec: 0,
              usedSec: 0,
              nbRollSec: 0,
            };
          }
          break;
        }
        default:
          break;
      }
    });

    return costs;
  }
}

export default StandardService;



// WEBPACK FOOTER //
// ./src/services/StandardService.js